var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-swipe',{attrs:{"autoplay":6000,"show-indicators":true}},_vm._l((_vm.images),function(image,index){return _c('van-swipe-item',{key:index},[_c('img',{staticClass:"imgSwiper",attrs:{"src":image.Column1},on:{"click":function($event){return _vm.Previewimg(_vm.images,index)}}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }